import React from "react";
import { PrivacyPolicyContent } from "../../components";

const PrivacyPolicy = () => {
  return <PrivacyPolicyContent />;
};

export default PrivacyPolicy;
